import { render, staticRenderFns } from "./commission-list.vue?vue&type=template&id=c56f57e4"
import script from "./commission-list.ts?vue&type=script&lang=js&external"
export * from "./commission-list.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports